import React from 'react';
import { Link } from 'react-router-dom';
import Sheet from './Sheet';
import OptionPicker from './OptionPicker';
import { usePurchase } from './usePurchase';
import { openBag } from './ui';
import { CHECKOUT_ENABLED } from './storeConfig';
import { formatInr, retailPrice } from './retailUtils';

/** Pick a size and add from a product list, without opening the product page. */
export default function QuickView({ product, onClose }) {
  const p = usePurchase(product);
  const { price, mrp, hasDiscount, discountPercent } = retailPrice(product);
  const image = p.variantImage || product.thumbnailUrl;

  const footer = (
    <div className="rt-qv-actions">
      <button type="button" className={`rt-btn${CHECKOUT_ENABLED ? ' rt-btn--ghost' : ''}`} disabled={p.soldOut || (p.complete && p.maxAdd <= 0)}
        onClick={() => { if (p.add()) { onClose(); openBag(); } }}>
        Add to bag
      </button>
      {CHECKOUT_ENABLED && (
        <button type="button" className="rt-btn" disabled={p.soldOut || (p.complete && p.maxAdd <= 0)}
          onClick={() => { const ready = p.complete; p.buyNow(); if (ready) onClose(); }}>
          Buy now
        </button>
      )}
    </div>
  );

  return (
    <Sheet open onClose={onClose} title="Choose your options" side="center" footer={footer}>
      <div className="rt-qv">
        <Link to={`/product/${product.id}`} className="rt-qv-img" onClick={onClose} tabIndex={-1} aria-hidden="true">
          {image && <img src={image} alt="" />}
        </Link>
        <div style={{ minWidth: 0 }}>
          {product.brandName && <div className="rt-card-brand">{product.brandName}</div>}
          <div className="rt-qv-name">{product.name}</div>
          <div className="rt-price">
            <span className="rt-price-now">{formatInr(price)}</span>
            {hasDiscount && <><span className="rt-price-mrp">{formatInr(mrp)}</span><span className="rt-price-off">{discountPercent}% off</span></>}
          </div>
          <Link to={`/product/${product.id}`} className="rt-link" style={{ fontSize: 13 }} onClick={onClose}>View full details</Link>
        </div>
      </div>
      <OptionPicker idPrefix="qv" options={p.options} color={p.color} size={p.size} onColor={p.pickColor} onSize={p.pickSize} missing={p.missing} />
      {p.complete && p.stock != null && p.stock > 0 && p.stock <= 5 && <div className="rt-stock rt-stock--low">Only {p.stock} left</div>}
      {p.inBag > 0 && <div className="rt-stock">{p.inBag} already in your bag</div>}
    </Sheet>
  );
}
